module.exports = __webpack_public_path__ + "static/fonts/iconfont.f12d7e1.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/content_font/iconfont.ttf?t=1614850630108
// module id = SX1k
// module chunks = 133